import React, { useEffect, useState } from 'react'
import { signIn, signUp } from '../../actions';
import { Avatar, Button, Paper, Grid, Typography, Container, CircularProgress } from "@material-ui/core";
import Alert from '@material-ui/lab/Alert'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';

import useStyles from './styles';
import Input from './Input';

import { useDispatch, useSelector } from 'react-redux';
import history from '../history';


//ErrorCodes that are received from the back end
// 1 -Sign Up- UserName is already Taken
// 2 -Sign Up- email is already in use
// 3 -Sign In This user name doesn't exist
// 4 -Sign In This is the incorrect password for the user
const initialFormState = { firstName: '', lastName: '', userName: '', email: '', password: '', confirmPassword: '' };

const errorFunctionForEmailSignUp = {
    errorFunction: (value) => {
        let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (value["email"].length < 1) return false;
        return !re.test(String(value["email"]).toLowerCase());
    },
    errorMessage: "Please enter a valid email."
}

const errorFunctionForEmailSignIn = {
    errorFunction: (value) => {
        if (value["email"].length === 0) return false;
        return (value["email"].length < 3)
    },
    errorMessage: "Entry is to short."
}

const errorList = {


    firstName: {
        errorFunction: (value) => {
            if (value["firstName"] === "") return false;
            if (value["firstName"].length > 1) return false;
            return true;
        }
    },
    lastName: {
        errorFunction: (value) => {
            if (value["lastName"] === "") return false;
            if (value["lastName"].length > 1) return false;
            return true;
        }
    },
    userName: {
        errorFunction: (value) => {
            if (value["userName"] === "") return false;
            if (value["userName"].length > 2) return false;
            return true;

        },
        errorMessage: "User name must be longer than 2 letters.",
    },
    email: errorFunctionForEmailSignIn,
    password: {
        errorFunction: (value) => {
            if (value["password"] === "") return false;
            if (value["password"].length > 5) return false;
            return true;

        },
        errorMessage: "Password must be longer than 5 letters."
    },
    confirmPassword: {
        errorFunction: (value) => {
            if (value["password"] === value["confirmPassword"]) return false;
            return true;
        },
        errorMessage: "Passwords do not match."
    }

}






const LandingPage = () => {

    const dispatch = useDispatch();
    const isSignedIn = useSelector((state) => state.auth.isSignedIn);
    const isSigningIn = useSelector((state) => state.auth.isSigningIn);
    const [signingInLocal, setSigningInLocal] = useState(false);


    useEffect(() => {
        if (isSignedIn) {
            history.push('/dashBoard');
        }

        if (isSignUp) {

            errorList["email"] = errorFunctionForEmailSignUp;
        } else {
            errorList["email"] = errorFunctionForEmailSignIn;
        }

    })
    const checkSignUpErrors = () => {
        return errorList["userName"].errorFunction(formData) || errorList["password"].errorFunction(formData) || errorList["confirmPassword"].errorFunction(formData) || errorList["email"].errorFunction(formData) || errorList["firstName"].errorFunction(formData) || errorList["lastName"].errorFunction(formData);
    }
    const checkSignInErrors = () => {
        return errorList["email"].errorFunction(formData) || errorList["password"].errorFunction(formData);
    }


    const classes = useStyles();
    const [showPassword, setShowPassword] = useState(false);
    const [showRepeatPassword, setShowRepeatPassword] = useState(false);
    const [isSignUp, setIsSignUp] = useState(false);
    const [formData, setFormData] = useState(initialFormState);


    //Error code management, error codes are listed at top of page
    //These error codes were made to accept the errors from the back and and show them in the front end
    const [showBackEndError1, setBackEndError1] = useState(false);
    const [showBackEndError2, setBackEndError2] = useState(false);
    const [showBackEndError3, setBackEndError3] = useState(false);
    const [showBackEndError4, setBackEndError4] = useState(false);

    //This function resets the error. I'll be using this when someone types in a field to get rid of the errors
    const setAllErrorCodesFalse = () => {
        setBackEndError1(false);
        setBackEndError2(false);
        setBackEndError3(false);
        setBackEndError4(false);
    }

    //This function will intake a code and turn the corresponding error on
    const turnErrorCodeOn = (code) => {
        switch (code) {
            case 1:
                setBackEndError1(true);
                break;
            case 2:
                setBackEndError2(true);
                break;
            case 3:
                setBackEndError3(true);
                break;
            case 4:
                setBackEndError4(true);
                break;
            default:
                break;
        }
    }





    const handleShowPassword = () => setShowPassword((prevShowPassword) => !prevShowPassword);
    const handleShowRepeatPassword = () => setShowRepeatPassword((prevShowRepeatPassword) => !prevShowRepeatPassword);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (isSignUp) {
            if (!checkSignUpErrors()) {
                (async () => {
                    try {
                        setSigningInLocal(true);
                        await dispatch(signUp(formData))

                    } catch (err) {
                        if (err.response.data.errorCode) {

                            turnErrorCodeOn(err.response.data.errorCode);
                        }
                    }
                    setSigningInLocal(false);
                })();

            }
        } else {
            (async () => {
                if (!checkSignInErrors()) {
                    try {
                        setSigningInLocal(true);
                        await dispatch(signIn(formData))

                    } catch (err) {
                        if (err.response) {
                            if (err.response.data) {
                                if (err.response.data.errorCode) {


                                    turnErrorCodeOn(err.response.data.errorCode);
                                }
                            }
                        }
                    }
                }
                setSigningInLocal(false);
            })();

            
        }




    }
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setAllErrorCodesFalse();

    }

    const resetForms = () => {
        setFormData(initialFormState);
    }

    const switchMode = () => {
        setIsSignUp((prevIsSignUp) => !prevIsSignUp);
        resetForms();
        setAllErrorCodesFalse();

    }


    if (isSigningIn || signingInLocal) {
        return (
            <Container component="main" maxWidth="xs" justify="center" align-items="center">


                <Paper className={classes.paper} elevation={3}>
                    <CircularProgress className={classes.spinner} />
                    <Typography className={classes.loadingText}> Signing you in </Typography>

                </Paper>

            </Container>
        )
    }


    return (
        <Container component="main" maxWidth="xs" justify="center" align-items="center">
            <Paper className={classes.paper} elevation={3}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>

                <Typography variant="h5">{isSignUp ? 'Sign Up' : 'Sign In'}</Typography>
                <form className={classes.form} onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        {
                            isSignUp && (
                                <React.Fragment>


                                    <Input name="firstName" label="First Name" value={formData} handleChange={handleChange} autoFocus errorManage={errorList} half />
                                    <Input name="lastName" label="Last Name" value={formData} handleChange={handleChange} errorManage={errorList} half />
                                    <Input name="userName" label="User Name" value={formData} handleChange={handleChange} errorManage={errorList} />
                                    {showBackEndError1 ? <Alert severity="error"> User name is already taken. </Alert> : null}



                                </React.Fragment>


                            )
                        }
                        <Input name="email" label="Email/User name" value={formData} handleChange={handleChange} type="text" autoFocus errorManage={errorList} />
                        {showBackEndError2 ? <Alert severity="error"> This email has already created an account.  </Alert> : null}
                        {showBackEndError3 ? <Alert severity="error"> This name/email does not have an account.  </Alert> : null}
                        <Input name="password" label="Password" value={formData} handleChange={handleChange} type={showPassword ? "text" : "password"} handleShowPassword={handleShowPassword} errorManage={errorList} />
                        {showBackEndError4 ? <Alert severity="error">  Incorrect Password  </Alert> : null}
                        {isSignUp ? (
                            <Input name="confirmPassword" label="Confirm password" value={formData} handleChange={handleChange} type={showRepeatPassword ? "text" : "password"} handleShowPassword={handleShowRepeatPassword} errorManage={errorList} />

                        ) : null}


                    </Grid>
                    <Button type="submit" fullWidth variant="contained" color="primary" className={classes.submit}>
                        {isSignUp ? 'Sign Up' : 'Sign In'}
                    </Button>
                    <Grid container justify="flex-end">
                        <Grid item >
                            <Button size="small" onClick={switchMode}>
                                {isSignUp ? 'Already have an account? Sign In' : "Don't have an account? Sign Up"}
                            </Button>
                        </Grid>

                    </Grid>



                </form>
            </Paper>


        </Container>
    )

}



export default LandingPage;